import { render, staticRenderFns } from "./AddContacts.vue?vue&type=template&id=30ea4ba8&scoped=true&lang=true"
import script from "./AddContacts.vue?vue&type=script&lang=js"
export * from "./AddContacts.vue?vue&type=script&lang=js"
import style0 from "./AddContacts.vue?vue&type=style&index=0&id=30ea4ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ea4ba8",
  null
  
)

export default component.exports